"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateContactInfoDto = exports.UserEventActions = exports.EventTypes = exports.UserKinds = void 0;
var UserKinds;
(function (UserKinds) {
    UserKinds["Unknown"] = "Unknown";
    UserKinds["Internal"] = "Internal";
    UserKinds["External"] = "External";
})(UserKinds = exports.UserKinds || (exports.UserKinds = {}));
var EventTypes;
(function (EventTypes) {
    EventTypes["UserEvent"] = "UserEvent";
    EventTypes["UserProfile"] = "UserProfile";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var UserEventActions;
(function (UserEventActions) {
    UserEventActions["UserCreated"] = "UserCreated";
    UserEventActions["UserUpdated"] = "UserUpdated";
    UserEventActions["UserDeleted"] = "UserDeleted";
    UserEventActions["CreateUser"] = "CreateUser";
    UserEventActions["UpdateUser"] = "UpdateUser";
    UserEventActions["DeleteUser"] = "DeleteUser";
    UserEventActions["UserProfileUpdate"] = "UserProfileUpdate";
})(UserEventActions = exports.UserEventActions || (exports.UserEventActions = {}));
class UpdateContactInfoDto {
}
exports.UpdateContactInfoDto = UpdateContactInfoDto;
